































// vue
import {
    defineComponent,
    onMounted,
    ref,
    computed,
} from '@vue/composition-api';

// services
import { useService } from '@/vue3/api/services';

// primevue
import ProgressSpinner from 'primevue/progressspinner';
import Dropdown from 'primevue/dropdown';
import InlineMessage from 'primevue/inlinemessage';

export default defineComponent({
    components: {
        ProgressSpinner,
        Dropdown,
        InlineMessage,
    },
    props: {
        geoRecord: {
            type: Object,
            default: () => {},
        },
        handleGeoRecordPropertyUpdate: {
            type: Function,
            default: () => {},
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
    },
    setup(props: any) {
        // hooks
        const { getAllGeoRecordModels } = useService();

        // reactive
        const selectedModel = ref();
        const models = ref();

        // lifecycle
        onMounted(async () => {
            models.value = await getAllGeoRecordModels();
            if (models.value !== null) {
                models.value.unshift({ id: null, name: 'No Model' });
            }
        });

        return {
            models,
            selectedModel,
        };
    },
});
